import { ELEMENT_NODE } from '@@constants/NodeTypes';

import { castArray } from './arrayUtils';

export const decodeImage = (image: HTMLImageElement) => {
    // JSDOM does not yet support `decode`, so we need to check if it is available:
    // https://github.com/jsdom/jsdom/issues/2154
    if (typeof image.decode === 'function') {
        return image.decode();
    }

    return new Promise((resolve, reject) => {
        // oxlint-disable-next-line no-param-reassign
        image.onload = resolve;
        // oxlint-disable-next-line no-param-reassign
        image.onerror = reject;
    });
};

// @ts-expect-error TS7006 Issue #4120
export const isFile = (value): value is File => value instanceof File;

export const getScrollContainer = (node: HTMLElement | null): HTMLElement | Window => {
    if (node == null) {
        return window;
    }

    if (node.nodeType === ELEMENT_NODE) {
        const { overflowY } = window.getComputedStyle(node);

        if (overflowY === 'auto' || overflowY === 'scroll') {
            return node;
        }
    }

    return getScrollContainer(node.parentElement);
};

// @ts-expect-error TS7006 Issue #4120
export const updateRef = (refs, instance) => {
    castArray(refs).forEach((ref) => {
        if (typeof ref === 'function') {
            ref(instance);
        } else if (ref != null && ref.hasOwnProperty('current')) {
            // oxlint-disable-next-line no-param-reassign
            ref.current = instance;
        }
    });
};
